package com.milta.core.localization.translations.nl

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Team",
    statusActive = "Actief",
    errorGeneric = "Er is een fout opgetreden. Probeer opnieuw.",
    monthNames = listOf("januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"),
    enterpriseSectionLabel = "Chauffeurs van het team",
    enterpriseEmptyHint = "Nog geen chauffeurs in uw team.",
    noEnterpriseFound = "Geen onderneming gekoppeld aan uw account.",
    columnHeaderDriver = "Chauffeur",
    columnHeaderStatus = "Status",
    columnHeaderActions = "Acties",
    addDriverSectionTitle = "Chauffeur toevoegen",
    addDriverCodePlaceholder = "Milta-code — bijv. MTA-28371",
    addDriverButton = "Deze chauffeur toevoegen",
    addDriverErrorInvalidCode = "Voer een geldige code in.",
    addDriverErrorNotFound = "Ongeldige of al gebruikte code.",
    addDriverErrorAlreadyMember = "Deze chauffeur maakt al deel uit van uw team.",
    addDriverErrorLinkedAccountIsEnterprise = "Dit account is een onderneming en kan niet als chauffeur worden toegevoegd.",
    addDriverErrorLimitReached = "Limiet bereikt: een onderneming kan niet meer dan 10 leden hebben, uzelf inbegrepen. Verwijder een chauffeur om een andere toe te voegen.",
    addDriverErrorEnterpriseSubscriptionInactive = "Uw Onderneming-abonnement is verlopen: verleng het om een chauffeur toe te voegen.",
    driverDetailTitle = "Chauffeurgegevens",
    driverDetailPhoneLabel = "Telefoon",
    removeDriverButton = "Verwijderen",
    removeDriverDialogTitle = "Deze chauffeur verwijderen?",
    removeDriverDialogMessagePrefix = "U staat op het punt om",
    removeDriverDialogMessageSuffix = "uit uw team te verwijderen. Zijn/haar Milta-account blijft actief.",
    removeDriverErrorNotFound = "Chauffeur niet gevonden.",
    removeDriverErrorOnActiveDelivery = "Deze chauffeur is momenteel bezig met een levering en kan niet worden verwijderd.",
    removeDriverErrorLastOwner = "U bent de enige beheerder van dit bedrijf. Voeg een ander bedrijfsaccount toe voordat u zichzelf uit het team verwijdert.",
)
